//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, inject } from '@angular/core';
import { first, firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { AdminService } from 'src/app/Services/Global/Admin/admin.service';



//-================ IMPORTS FOR DEPENDENCIES ================-\\
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Response_GeneralCDMS } from 'src/app/Interfaces/GeneralCDMS/Response_GeneralCDMS.interface';
import { Group, Group_New_Format } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Group.interface';
import { Response_Admin } from 'src/app/Interfaces/Admin/Response_Admin.interface';
import { ABC_Group } from 'src/app/Interfaces/Admin/Group_CDMS.interface';
import { FilterGroupPipe } from 'src/app/Pipes/Admin/filter-group.pipe';
import { Router } from '@angular/router';
import { Permission, Permission_Key, Permissions, Permissions_CDMS } from 'src/app/Constants/Admin/Permissions';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';



@Component({
    selector: 'app-admin-groups-of-cdms',
    templateUrl: './admin-groups-of-cdms.component.html',
    styleUrls: ['./admin-groups-of-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class AdminGroupsOfCDMSComponent implements OnInit {

  //-===================================== SECTION FORMS =====================================-\\

  //+===================== FORM ADD NEW GROUP =====================+\\
  public Form_Group_Create: FormGroup = new FormGroup({
    Name: new FormControl('', [Validators.required, Validators.minLength(10)]),
    Description: new FormControl('', [Validators.required, Validators.minLength(15)]),
    LibrarySlug: new FormControl(''),
    Administrator: new FormControl(false),
    Read: new FormControl(false),
    Contributor: new FormControl(false),
    Reviewer: new FormControl(false),
    Approver: new FormControl(false),
    Delete: new FormControl(false),
    Version_History: new FormControl(false),
    Report: new FormControl(false),
    Create_Folder: new FormControl(false),
    Approval_Flow: new FormControl(false),
    Rename_File: new FormControl(false),
    Rename_Folder: new FormControl(false),
    Properties: new FormControl(false),
    Move_File: new FormControl(false),
    Recycle_Bin: new FormControl(false),
    Shared_Folder: new FormControl(false),
  })


  //+===================== FORM UPDATE GROUP =====================+\\
  public Form_Group_Update: FormGroup = new FormGroup({
    ID_G: new FormControl(0, [Validators.required, Validators.pattern(/\d+/)]),
    Name: new FormControl('', [Validators.required, Validators.minLength(10)]),
    Description: new FormControl('', [Validators.required, Validators.minLength(15)]),
    LibrarySlug: new FormControl(''),
    Administrator: new FormControl(false),
    Read: new FormControl(false),
    Contributor: new FormControl(false),
    Reviewer: new FormControl(false),
    Approver: new FormControl(false),
    Delete: new FormControl(false),
    Version_History: new FormControl(false),
    Report: new FormControl(false),
    Create_Folder: new FormControl(false),
    Approval_Flow: new FormControl(false),
    Rename_File: new FormControl(false),
    Rename_Folder: new FormControl(false),
    Properties: new FormControl(false),
    Move_File: new FormControl(false),
    Recycle_Bin: new FormControl(false),
    Shared_Folder: new FormControl(false),
  })

  //+================== VARIABLES GLOBAL FILES FIN ==================+\\
  public All_Groups_Source: Group_New_Format[] = [];
  public All_Groups: Group_New_Format[] = [];
  public All_Groups_Copy: Group_New_Format[] = [];
  public All_Groups_Copy_Table: Group_New_Format[] = [];
  public All_Groups_Copy_Search: Group_New_Format[] = [];

  //+================== VARIABLES FOR HEADERS GROUPS ==================+\\
  public Headers_Groups: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAM' },
    { ID: 1, Name: 'Librería', Position: 1, Visible: true, Key_Header: 'LIB' },
    { ID: 1, Name: 'Descripción', Position: 1, Visible: true, Key_Header: 'DES' },
    { ID: 1, Name: 'Permisos', Position: 1, Visible: true, Key_Header: 'PER' },
    { ID: 1, Name: 'Opciones', Position: 1, Visible: true, Key_Header: 'OPTIO' },
  ];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Input_Search: string = '';
  public Input_Search_Table: string = '';
  public SelectedLibraryFilter: string | null = null;
  public ActiveLibraries: Array<{ Name: string, Slug: string }> = [];
  public LibraryFilterOptions: Array<{ Name: string, Slug: string }> = [];
  public LibraryFormOptions: Array<{ Name: string, Slug: string }> = [];
  public CanManageGlobalScope: boolean = false;
  private IsSuperAdminScope: boolean = false;
  private AllowedLibrarySlugs: Set<string> = new Set<string>();


  //+================== VARIABLES FOR PAGINATION ==================+\\
  public first: number = 0;
  public rows: number = 10;


  //+================== VARIABLES FOR PERMISSIONS ==================+\\
  public P_CDMS = Permissions;

  //+================== VARIABLES FOR LOAD PAGE & VIEW ==================+\\
  public LoadPage: boolean = false;
  public isList: boolean = true;

  //+================== VARIABLES FOR PERMISIONS ==================+\\
  public Permisions: Permissions[] = Permissions_CDMS;


  //-========================= SERVICES =========================-\\
  private Service_Admin = inject(AdminService);
  private Service_GeneralCDMS = inject(GeneralCDMSService);
  private Service_MasterLibrary = inject(LibraryMasterService);
  private UserService = inject(UserDataService);
  private router = inject(Router);

  constructor() { }


  ngOnInit(): void {
    this.UserService.RefrestDataUser();
    this.Load_Component();
  }


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    this.LoadPage = false;

    try {
      await this.Load_Active_Libraries();

      const Res_Group: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_All_Groups());

      if (Res_Group.success) {

        this.All_Groups_Source = (Res_Group.operation || []).map((group: any) => ({
          ...group,
          Nombre: String(group?.Nombre || ''),
          Descripcion: String(group?.Descripcion || ''),
          Library_Slug: this.Normalize_Library_Slug(group?.Library_Slug)
        }));
        this.Apply_Library_Filter();

        Loader.classList.remove('active');
        this.LoadPage = true;
      } else {
        throw Res_Group.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Usuarios)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  private async Load_Active_Libraries(): Promise<void> {
    try {
      // Esperar a que el contexto del usuario esté listo para evaluar alcance por rol.
      await firstValueFrom(this.UserService.GetDataUser.pipe(first((value) => value.ID !== 0)));

      const response: any = await firstValueFrom(this.Service_MasterLibrary.Get_Active_Libraries());

      if (!response?.success || !Array.isArray(response.operation)) {
        this.ActiveLibraries = [];
        return;
      }

      const allLibraries = response.operation
        .map((lib: any) => ({
          Name: String(lib?.Nombre || lib?.Name || lib?.Slug || '').trim(),
          Slug: String(lib?.Slug || '').trim().toLowerCase()
        }))
        .filter((lib: { Name: string, Slug: string }) => lib.Slug.length > 0);

      const staticProcessesLibrary = { Name: 'Processes', Slug: 'fin' };
      const staticHOELibrary = { Name: 'HOE', Slug: 'hoe' };

      this.IsSuperAdminScope = this.UserService.IsSuperAdministrator();
      this.CanManageGlobalScope = this.IsSuperAdminScope || this.UserService.UserHasAnyAdministratorRole();

      // Filtrar librerías según alcance del usuario
      if (this.IsSuperAdminScope) {
        // Super Admin ve todas las librerías
        this.AllowedLibrarySlugs = new Set(allLibraries.map((lib: { Name: string, Slug: string }) => lib.Slug));
      } else {
        // Usuario regular: Solo ve librerías donde es Administrator<SLUG>
        this.AllowedLibrarySlugs = new Set(
          allLibraries
            .filter((lib: { Name: string, Slug: string }) => this.UserService.UserIsAdministratorOfLibrary(lib.Slug))
            .map((lib: { Name: string, Slug: string }) => lib.Slug)
        );
      }

      // Processes y HOE son librerías base del sistema y deben estar disponibles siempre.
      this.AllowedLibrarySlugs.add(staticProcessesLibrary.Slug);
      this.AllowedLibrarySlugs.add(staticHOELibrary.Slug);

      // Mostrar solo librerías permitidas en el dropdown
      this.ActiveLibraries = allLibraries.filter((lib: { Name: string, Slug: string }) => this.AllowedLibrarySlugs.has(lib.Slug));

      if (!this.ActiveLibraries.some((lib: { Name: string, Slug: string }) => lib.Slug === staticProcessesLibrary.Slug)) {
        this.ActiveLibraries.unshift(staticProcessesLibrary);
      }

      if (!this.ActiveLibraries.some((lib: { Name: string, Slug: string }) => lib.Slug === staticHOELibrary.Slug)) {
        this.ActiveLibraries.push(staticHOELibrary);
      }

      this.Refresh_Library_Options();

      if (!this.IsSuperAdminScope) {
        const currentFilter = String(this.SelectedLibraryFilter || '').trim().toLowerCase();
        if (!currentFilter || currentFilter === '__global__' || !this.AllowedLibrarySlugs.has(currentFilter)) {
          this.SelectedLibraryFilter = null;
        }
      }
    } catch (error) {
      this.ActiveLibraries = [];
      this.LibraryFilterOptions = [];
      this.LibraryFormOptions = [];
    }
  }

  private Refresh_Library_Options(): void {
    this.LibraryFilterOptions = [
      { Name: 'Solo GLOBAL', Slug: '__global__' },
      ...this.ActiveLibraries,
    ];

    this.LibraryFormOptions = [
      { Name: 'GLOBAL (todas)', Slug: '__global__' },
      ...this.ActiveLibraries,
    ];
  }

  private Normalize_Library_Slug(value: any): string | null {
    const normalized = String(value || '').trim().toLowerCase();
    return normalized.length > 0 ? normalized : null;
  }

  private Normalize_Form_Library_Slug(value: any): string | null {
    const normalized = String(value || '').trim().toLowerCase();

    if (normalized === '' || normalized === '__global__') {
      return null;
    }

    return normalized;
  }

  public OnChange_Library_Filter(): void {
    this.first = 0;
    this.Input_Search = '';
    this.Apply_Library_Filter();
  }

  private Apply_Library_Filter(): void {
    const currentFilter = String(this.SelectedLibraryFilter || '').trim().toLowerCase();

    if (currentFilter === '') {
      this.All_Groups = [...this.All_Groups_Source];
    } else if (currentFilter === '__global__') {
      this.All_Groups = this.All_Groups_Source.filter((group) => this.Normalize_Library_Slug(group.Library_Slug) === null);
    } else {
      this.All_Groups = this.All_Groups_Source.filter((group) => this.Normalize_Library_Slug(group.Library_Slug) === currentFilter);
    }

    if (!this.IsSuperAdminScope) {
      this.All_Groups = this.All_Groups.filter((group) => {
        const groupLibrarySlug = this.Normalize_Library_Slug(group.Library_Slug);
        return groupLibrarySlug === null || this.AllowedLibrarySlugs.has(groupLibrarySlug);
      });
    }

    this.Search_Group();
  }

  public Get_Library_Badge(librarySlug?: string | null): string {
    if (!librarySlug) return 'GLOBAL';
    const slug = librarySlug.trim().toLowerCase();
    if (slug === 'fin' || slug === 'processes') return 'processes';
    return librarySlug.toUpperCase();
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\





  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR PAGINATION ==================-\\
  public onPageChange(event: any): void {

    this.first = event.first;
    this.rows = event.rows;

    this.All_Groups_Copy = this.Input_Search.length < 2 ? this.All_Groups.slice(event.first, event.first + event.rows) : this.All_Groups_Copy_Search.slice(event.first, event.first + event.rows);

  }

  //-================== FUNCTTION FOR INITIALS CARD ==================-\\
  public Format_Initials(Name: string): string {
    let Initials: string = '';
    const safeName = String(Name || '').trim();
    let NameSplit: string[] = safeName.length > 0 ? safeName.split(' ') : [];

    if (NameSplit.length === 0) {
      return '??';
    }

    Initials += NameSplit[0][0] || '?';
    NameSplit.length > 1 ? Initials += NameSplit[1][0] || '' : Initials += NameSplit[0][1] || '?';

    return Initials;
  }

  //-================== FUNCTTION FOR FORMAT DESCRIPTION ==================-\\
  public Format_Description(Description: string | null | undefined): string {
    const safeDescription = String(Description || '').trim();

    return safeDescription === '' ? 'Este grupo aún no tiene descripción, se le recomienda asignarle alguna descripción al grupo para asi identificarlo más rápido.' : safeDescription;

  }



  //-================== FUNCTTION OPEN OR CLOSE MODAL OPTIONS FOR GROUPS ==================-\\
  public Toggle_Modal_Option(Position: number): void {
    const Card_Option = document.getElementById(`Card_Option${Position}`) as HTMLElement;
    Card_Option.classList.toggle('active')
  }

  //-================ FUNCTION FOR VALIDATE SEARCH ================-\\
  public Search_Validate(): void {

    if (this.Input_Search.length < 2) {
      Swal.fire({
        title: 'búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_Group();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_Enter($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate() : 0;
  }

  //-================== FUNCTTION FOR SEARCH GROUP ==================-\\
  public Search_Group(): void {
    this.Input_Search == '' || this.Input_Search.length < 2 ? this.All_Groups_Copy = this.All_Groups.slice(this.first, this.first + this.rows) : (this.All_Groups_Copy_Search = new FilterGroupPipe().transform(this.All_Groups, this.Input_Search), this.All_Groups_Copy = this.All_Groups_Copy_Search.slice(this.first, this.first + this.rows));
  }

  //-================== FUNCTTION FOR RELOAD PAGE ==================-\\
  public Reload_Page(): void {
    this.Load_Component();
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\





  //&===================== FUNCTIONS FOR CREATE GROUP =====================&\\


  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL FOR ADD GROUP ==================-\\
  public Toggle_Modal_Create_Group(CloseOrOpen: boolean): void {
    this.Reset_Form_Create_Group();
    const Modal_Create_Group = document.getElementById('Modal_Create_Group') as HTMLDivElement;
    CloseOrOpen ? Modal_Create_Group.classList.add('active') : Modal_Create_Group.classList.remove('active');
  }

  //-================== FUNCTTION FOR RESET FORM NEW GROUP ==================-\\
  private Reset_Form_Create_Group(): void {
    this.Form_Group_Create.reset();
    this.Form_Group_Create.controls['Name'].setValue('')
    this.Form_Group_Create.controls['Description'].setValue('')
    this.Form_Group_Create.controls['LibrarySlug'].setValue(null)
    this.Form_Group_Create.controls['Administrator'].setValue(false)
    this.Form_Group_Create.controls['Read'].setValue(false)
    this.Form_Group_Create.controls['Contributor'].setValue(false)
    this.Form_Group_Create.controls['Reviewer'].setValue(false)
    this.Form_Group_Create.controls['Approver'].setValue(false)
    this.Form_Group_Create.controls['Delete'].setValue(false)
    this.Form_Group_Create.controls['Version_History'].setValue(false)
    this.Form_Group_Create.controls['Report'].setValue(false)
    this.Form_Group_Create.controls['Create_Folder'].setValue(false)
    this.Form_Group_Create.controls['Approval_Flow'].setValue(false)
    this.Form_Group_Create.controls['Rename_File'].setValue(false)
    this.Form_Group_Create.controls['Rename_Folder'].setValue(false)
    this.Form_Group_Create.controls['Properties'].setValue(false)
    this.Form_Group_Create.controls['Move_File'].setValue(false)
    this.Form_Group_Create.controls['Recycle_Bin'].setValue(false)
    this.Form_Group_Create.controls['Shared_Folder'].setValue(false)
  }

  //-================== FUNCTTION FOR SAVED GROUP ==================-\\
  public Save_Group(): void {

    const IsValidForm: boolean = this.Is_Valid_Form_New_Group();

    if (this.Form_Group_Create.valid && IsValidForm) {

      Swal.fire({
        title: '¿Los datos son correctos?',
        text: "Si todo esta bien, presiona el botón para continuar",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
        cancelButtonText: 'No, Cancelar',
      }).then((async result => {
        if (result.isConfirmed) {

          try {

            const Send_Data: ABC_Group = {
              ...this.Form_Group_Create.value,
              Administrator: false,
              LibrarySlug: this.Normalize_Form_Library_Slug(this.Form_Group_Create.value.LibrarySlug)
            };

            const Res_Create: Response_Admin = await firstValueFrom(this.Service_Admin.Create_Group_CDMS(Send_Data));

            if (Res_Create.success) {
              Swal.fire({
                title: 'Grupo creado',
                text: '¡El grupo se guardo en el sistema correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              });
              this.Load_Component();
              this.Toggle_Modal_Create_Group(false);
            } else {
              throw Res_Create.message;
            }

          } catch (e) {
            Swal.fire({
              title: 'Error al guardar el grupo',
              text: '¡Error al guardar el grupo, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            })
            this.Load_Component();
            this.Toggle_Modal_Create_Group(false);
          }
        }
      }))
    }

  }

  //-================== FUNCTTION FOR VALIDATE PROPERTIES OF GROUP FOR SEND ==================-\\
  private Is_Valid_Form_New_Group(): boolean {
    const Idinput_Name_Group = document.getElementById('Idinput_Name_Group') as HTMLElement;
    const Idinput_Desc_Group = document.getElementById('Idinput_Desc_Group') as HTMLElement;

    if (!this.Form_Group_Create.controls['Name'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Nombre no valido',
        text: '¡El nombre del grupo es muy corto, mínimo 10 caracteres!',
        confirmButtonColor: this.ColorConfirm
      })
      Idinput_Name_Group.classList.add('ng-invalid'); Idinput_Name_Group.classList.add('ng-touched');
      return false;
    }

    if (!this.Form_Group_Create.controls['Description'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'descripción no valido',
        text: '¡La descripción del grupo es muy corta, mínimo 15 caracteres!',
        confirmButtonColor: this.ColorConfirm
      })
      Idinput_Desc_Group.classList.add('ng-invalid'); Idinput_Desc_Group.classList.add('ng-touched');
      return false;
    }

    const createLibrarySlug = this.Normalize_Form_Library_Slug(this.Form_Group_Create.controls['LibrarySlug'].value);

    if (this.All_Groups.some(item => item.Nombre.trim().toLowerCase() === this.Form_Group_Create.controls['Name'].value.trim().toLowerCase() && this.Normalize_Library_Slug(item.Library_Slug) === createLibrarySlug)) {
      Swal.fire({
        icon: 'warning',
        title: 'Nombre no valido',
        text: '¡Ya existe un grupo con este nombre para la librería seleccionada!',
        confirmButtonColor: this.ColorConfirm
      })
      return false;
    }

    return true;
  }


  //&===================== END FUNCTIONS FOR CREATE GROUP =====================&\\






  //&===================== FUNCTIONS FOR DELETE GROUP =====================&\\

  //-================== FUNCTTION OPEN AND FILL MODAL FOR UPDATE GROUP ==================-\\
  public Open_Update_Group(Group: Group_New_Format) {
    const IsFill: boolean = this.Fill_Form_Group(Group);
    if (IsFill) {
      this.Toggle_Modal_Update_Group(true);
    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Vuelva a intentarlo, si el problema persiste notifique a su supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    }
  }

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL FOR UPDATE GROUP ==================-\\
  public Toggle_Modal_Update_Group(CloseOrOpen: boolean): void {
    const Modal_Update_Group = document.getElementById('Modal_Update_Group') as HTMLDivElement;
    CloseOrOpen ? Modal_Update_Group.classList.add('active') : Modal_Update_Group.classList.remove('active');
  }

  //-================== FUNCTTION FOR FILL FORM FOR UPDATE GROUP ==================-\\
  private Fill_Form_Group(Group: Group_New_Format): boolean {

    this.Form_Group_Update.reset();
    this.Form_Group_Update.controls['ID_G'].setValue(Group.ID_G);
    this.Form_Group_Update.controls['Name'].setValue(Group.Nombre);
    this.Form_Group_Update.controls['Description'].setValue(Group.Descripcion);
    this.Form_Group_Update.controls['LibrarySlug'].setValue(Group.Library_Slug || null);

    for (const Permission_G of Object.entries(Permissions)) {
      this.Form_Group_Update.controls[Permission_G[1]].setValue(Group.Permission.some((P: Permission) => P.toUpperCase() === this.P_CDMS[Permission_G[0] as Permission_Key].toUpperCase()))
    }

    return true;

  }

  //-================== FUNCTTION FOR SAVED CHANGES FOR UPDATE GROUP ==================-\\
  public Save_Group_Update(): void {

    const IsValidForm_Update: boolean = this.Is_Valid_Form_Update_Group();


    if (this.Form_Group_Update.valid && IsValidForm_Update) {

      Swal.fire({
        title: '¿Los datos son correctos?',
        text: "Si todo esta bien, presiona el botón para continuar",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
        cancelButtonText: 'No, Cancelar',
      }).then((async result => {
        if (result.isConfirmed) {

          try {

            const Send_Data: ABC_Group = {
              ...this.Form_Group_Update.value,
              Administrator: false,
              LibrarySlug: this.Normalize_Form_Library_Slug(this.Form_Group_Update.value.LibrarySlug)
            };


            const Res_Update: Response_Admin = await firstValueFrom(this.Service_Admin.Update_Group_CDMS(Send_Data));

            if (Res_Update.success) {
              Swal.fire({
                title: 'Grupo actualizado',
                text: '¡El grupo se actualizo correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              });
              this.Load_Component();
              this.Toggle_Modal_Update_Group(false);
            } else {
              throw Res_Update.message;
            }

          } catch (e) {
            Swal.fire({
              title: 'Error al actualizar el grupo',
              text: '¡Error al actualizar el grupo, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            })
            this.Load_Component();
            this.Toggle_Modal_Update_Group(false);
          }
        }
      }))
    }

  }

  //-================== FUNCTTION FOR VALIDATION FOR UPDATE GROUP ==================-\\
  private Is_Valid_Form_Update_Group(): boolean {
    const Idinput_Name_Group_Update = document.getElementById('Idinput_Name_Group_Update') as HTMLElement;
    const Idinput_Desc_Group_Update = document.getElementById('Idinput_Desc_Group_Update') as HTMLElement;

    if (!this.Form_Group_Update.controls['Name'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Nombre no valido',
        text: '¡El nombre del grupo es muy corto, mínimo 10 caracteres!',
        confirmButtonColor: this.ColorConfirm
      })
      Idinput_Name_Group_Update.classList.add('ng-invalid'); Idinput_Name_Group_Update.classList.add('ng-touched');
      return false;
    }

    if (!this.Form_Group_Update.controls['Description'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'descripción no valido',
        text: '¡La descripción del grupo es muy corta, mínimo 15 caracteres!',
        confirmButtonColor: this.ColorConfirm
      })
      Idinput_Desc_Group_Update.classList.add('ng-invalid'); Idinput_Desc_Group_Update.classList.add('ng-touched');
      return false;
    }

    const updateLibrarySlug = this.Normalize_Form_Library_Slug(this.Form_Group_Update.controls['LibrarySlug'].value);

    for (const Group of this.All_Groups) {

      if (Group.Nombre.trim().toLowerCase() === this.Form_Group_Update.controls['Name'].value.trim().toLowerCase() && Group.ID_G != this.Form_Group_Update.controls['ID_G'].value && this.Normalize_Library_Slug(Group.Library_Slug) === updateLibrarySlug) {
        Swal.fire({
          icon: 'warning',
          title: 'Nombre no valido',
          text: '¡Ya existe un grupo con este nombre para la librería seleccionada!',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      }
    }

    return true;
  }
  //&===================== END FUNCTIONS FOR DELETE GROUP =====================&\\




  //&===================== FUNCTIONS FOR DELETE GROUP =====================&\\

  //-================== FUNCTTION FOR DELETE GROUP ==================-\\
  public Delete_Group(Group: Group_New_Format): void {

    const NameDelete: string = Group.Nombre.trim();


    Swal.fire({
      title: '¿Está seguro de eliminar el grupo del sistema?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar el grupo escriba '${NameDelete}' !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {


              try {

                const Res_Delete_Group: Response_Admin = await firstValueFrom(this.Service_Admin.Delete_Group_CDMS({ ID_G: Group.ID_G }))

                if (Res_Delete_Group.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Grupo eliminado',
                    text: '¡Se eliminó correctamente el grupo!',
                    confirmButtonColor: this.ColorConfirm
                  })
                  this.Load_Component();
                } else {
                  throw Res_Delete_Group.message;
                }


              } catch (error) {
                Swal.fire({
                  title: 'Ocurrió un error',
                  text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del grupo para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }

  //&===================== END FUNCTIONS FOR DELETE GROUP =====================&\\

}
